import axios from 'axios';

// Providers
const fetchProviders = () => axios.get('mcp-skill-providers');
const fetchProvider = id => axios.get(`mcp-skill-providers/${id}`);
const createProvider = params => axios.post('mcp-skill-providers', params);
const updateProvider = ({ id, ...params }) => axios.put(`mcp-skill-providers/${id}`, params);
const deleteProvider = id => axios.delete(`mcp-skill-providers/${id}`);
const discoverSkills = id => axios.post(`mcp-skill-providers/${id}/discover`);
const getOAuthAuthorizeUrl = id => axios.get(`mcp-skill-providers/${id}/oauth/authorize-url`);

// Skills
const fetchSkills = () => axios.get('mcp-skills');
const fetchSkill = id => axios.get(`mcp-skills/${id}`);
const createSkill = params => axios.post('mcp-skills', params);
const updateSkill = ({ id, ...params }) => axios.put(`mcp-skills/${id}`, params);
const deleteSkill = id => axios.delete(`mcp-skills/${id}`);

export {
  fetchProviders,
  fetchProvider,
  createProvider,
  updateProvider,
  deleteProvider,
  discoverSkills,
  getOAuthAuthorizeUrl,
  fetchSkills,
  fetchSkill,
  createSkill,
  updateSkill,
  deleteSkill
};
